import * as React from "react";

import { Drawer } from "antd";
import { Button } from "#components/primitive/button";
import { useAnalytics } from "#structure/providers/analytics/analytics-provider";
import { useGetCurrentEmployee } from "#resources/hooks/integrations/auth/query";

import Icon from "#components/icon";
import s from "./suport-area.scss";
import { contextLevelFromUrl } from "#resources/helpers/url/url";
import { closeZendeskChat, openZendeskChat, ZENDESK_FIELD_IDS } from "#structure/providers/zendesk";

const DEFAULT_WIDTH_DESKTOP = 466;
const DEFAULT_WIDTH_MOBILE = "100%";
interface SuportAreaProps {
	type: "mobile" | "desktop";
	isOpen: boolean;
	placeName: string;
	handleChangeIsOpen: (isOpen: boolean) => void;
}
export function SuportArea({
	placeName,
	type,
	isOpen,
	handleChangeIsOpen,
}: SuportAreaProps) {
	const { data: currentEmployee } = useGetCurrentEmployee({});
	const { sendEvent } = useAnalytics();
	const contextLevel = contextLevelFromUrl();

	const handleClose = () => {
		closeZendeskChat();
		handleChangeIsOpen(false);
	};

	const handleContactSupport = () => {
		sendEvent("SUPPORT_WHATSAPP", {
			actionType: "click",
			userName: currentEmployee?.name ?? "",
			userLogin: currentEmployee?.username ?? "",
			placeName: placeName ?? "",
			positionName: currentEmployee?.role?.name ?? "",
			dateUserAction: new Date().toISOString(),
			contextLevel,
		});
	};

	return (
		<div>
			{isOpen ? (
				<Drawer
					className={s.suportArea}
					width={type === "mobile" ? DEFAULT_WIDTH_MOBILE : DEFAULT_WIDTH_DESKTOP}
					open={isOpen}
					title={
						<div className={s.headerInfos}>
							{type === "mobile" && <div className={s.handleMobile} />}
							<div className={s.titleContainer}>
								<h1 className={s.title}>{"Central de ajuda"}</h1>
								{type === "desktop" && (
									<Icon
										icon="close"
										className={s.closeButton}
										onClick={handleClose}
									/>
								)}
							</div>
						</div>
					}
					placement={type === "mobile" ? "bottom" : "right"}
					closable={false}
					onClose={handleClose}
					footer={
						type === "desktop" && (
							<div className={s.footer}>
								<Button variant="ghost" onClick={handleClose}>
									{"Fechar"}
								</Button>
							</div>
						)
					}
				>
					<div className={s.containerContacts}>
						<div className={s.contactWhatsApp}>
							<Icon className={s.iconChat} icon="chat" />
							<h2>Precisa de ajuda?</h2>
							<span>Converse com o nosso time de suporte.</span>
							<button
								className={s.link}
								onClick={() => {
									handleContactSupport();
									openZendeskChat([
										{ id: ZENDESK_FIELD_IDS.organization, value: currentEmployee?.organization.id ?? "" },
									]);
								}}
							>
								<span>Falar com o suporte</span>
								<Icon icon="arrow-right" />
							</button>
						</div>
					</div>
				</Drawer>
			) : null}
		</div>
	);
}
